import { createContext } from '../../../utils/react-helpers'
import type EventObserver from '../../_utils/event-observer'

export type DrawerContext = {
  onEnteredObserver?: EventObserver<() => void>
  onExitedObserver?: EventObserver<() => void>
}

const [DrawerContextProvider, useDrawerContext] = createContext<DrawerContext>({
  strict: false,
  name: 'DrawerContext'
})

export { DrawerContextProvider, useDrawerContext }
